import { bigFractionFromNumber } from "@aprao/common/src/math/BigFraction.js";
import type { CountableNumber } from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

import type { ShapeResidentialSalesItem } from "../../shapes/ShapeRevenueGroup.js";
import { relativesSetFacadeWithAbsolute } from "../RelativesSetFacade.js";
import { RevenueItemBaseFacade } from "./RevenueItemBaseFacade.js";

export class ResidentialSalesItemFacade {
  readonly $revenueItemBase;

  constructor(readonly $model: ShapeResidentialSalesItem) {
    makeAutoObservable(this);

    this.$revenueItemBase = new RevenueItemBaseFacade(this.$model);
  }

  get area() {
    return relativesSetFacadeWithAbsolute(this.$model.area, {
      ratioItem: () => bigFractionFromNumber(this.$model.quantity),
    });
  }

  get salePrice() {
    return relativesSetFacadeWithAbsolute(this.$model.salePrice, {
      ratioArea: () => this.area.relativesSet.getRelative("absolute"),
      ratioItem: () => bigFractionFromNumber(this.$model.quantity),
    });
  }

  get aggregateArea() {
    return this.area.relativesSet.getRelative("absolute") ?? null;
  }

  get aggregateValue() {
    return this.salePrice.relativesSet.getRelative("absolute") ?? null;
  }

  // below are all the delegates
  get description() {
    return this.$revenueItemBase.description;
  }

  set description(description: string) {
    this.$revenueItemBase.description = description;
  }

  get quantity() {
    return this.$revenueItemBase.quantity;
  }

  set quantity(unitCount: CountableNumber) {
    this.$revenueItemBase.quantity = unitCount;
  }
}
